import React from 'react';
import { Form, Card } from 'semantic-ui-react';

import AirlineDropdown from '../../../dropdowns/AirlineDropdown';
import AirportDropdown from '../../../dropdowns/AirportDropdown';
import RemoveFlightLabel from '../../../RemoveFlightLabel';
import DateAndTimeInputs from '../../../DateAndTimeInputs';
import Field from '../../../Field';

const Flight = ({
  errors,
  touched,
  flight,
  index,
  onBlur,
  onFlightChange,
  onFlightTimeChange,
  onRemoveFlight,
  flightId
}) => {
  const dateAndTimeWrapper = (name, blurAnchor, text) => (
    <DateAndTimeInputs
      value={flight[name]}
      errors={errors && errors[name]}
      touched={touched && touched[name]}
      handleBlur={onBlur.bind(this, blurAnchor)}
      setFieldValue={onFlightTimeChange.bind(this, flight.id)}
      name={name}
      text={text}
    />
  );

  return (
    <Card fluid className={`anchor-flights-${index}`}>
      <Card.Content>
        {flight.id !== flightId && (
          <RemoveFlightLabel
            flight={flight}
            handleRemoveFlight={onRemoveFlight}
          />
        )}
        <Form.Group widths="equal">
          <Field
            error={errors && errors.airportOrigin}
            touched={touched && touched.airportOrigin}
          >
            <AirportDropdown
              name="airportOrigin"
              label="Airport Origin *"
              placeholder="Airport Origin"
              value={flight.airportOrigin}
              onChange={onFlightChange.bind(this, flight.id)}
              onBlur={onBlur.bind(this, `flights[${index}].airportOrigin`)}
            />
          </Field>
          <Field
            error={errors && errors.airportDestination}
            touched={touched && touched.airportDestination}
          >
            <AirportDropdown
              name="airportDestination"
              label="Airport Destination *"
              placeholder="Airport Destination"
              value={flight.airportDestination}
              onChange={onFlightChange.bind(this, flight.id)}
              onBlur={onBlur.bind(
                this,
                `flights[${index}].airportDestination`
              )}
            />
          </Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Field
            error={errors && errors.airline}
            touched={touched && touched.airline}
          >
            <AirlineDropdown
              labelled
              placeholder
              value={flight.airline}
              onChange={onFlightChange.bind(this, flight.id)}
              onBlur={onBlur.bind(this, `flights[${index}].airline`)}
            />
          </Field>
          <Field
            error={errors && errors.number}
            touched={touched && touched.number}
          >
            <Form.Input
              style={{ opacity: 1 }}
              name="number"
              label="Flight number"
              placeholder="Flight number"
              value={flight.number}
              onChange={onFlightChange.bind(this, flight.id)}
              onBlur={onBlur.bind(this, `flights[${index}].number`)}
            />
          </Field>
        </Form.Group>
        <Form.Group>
          {dateAndTimeWrapper(
            'localDepartureDate',
            `flights[${index}].localDepartureDate`,
            '* Departure '
          )}
          {dateAndTimeWrapper(
            'localArrivalDate',
            `flights[${index}].localArrivalDate`,
            '* Arrival '
          )}
        </Form.Group>
      </Card.Content>
    </Card>
  );
};

export default Flight;



// WEBPACK FOOTER //
// ./src/component/tasks/CorrectClaimTask/Form/Flight.js